import { useConfig } from './useConfig';
import { PlatformAPI } from '../services/PlatformAPI';
import { useMemo } from 'react';

export function usePlatformAPI() {
  const { gatewayUrl } = useConfig();
  return useMemo(() => PlatformAPI(`${gatewayUrl}/platform`), [gatewayUrl]);
}
